module.exports = __webpack_public_path__ + "static/media/event1.cc192aac.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/event1.png
// module id = 1102
// module chunks = 21